import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { ToolsService } from 'src/app/recursos/tools.service';
import { IngresoService } from 'src/app/servicios/ingreso.service';
import { LoaderComponent } from 'src/app/servicios/loader/loader.component';
import { SeleccionService } from 'src/app/servicios/seleccion.service';

@Component({
  selector: 'app-ficha-preguntas',
  templateUrl: './ficha-preguntas.component.html',
  styleUrls: ['./ficha-preguntas.component.css']
})
export class FichaPreguntasComponent implements OnInit {

  public mr: NgbModalRef;

  public encabezado: string = "";
  public vecVerEncuesta = []; public vecVerTipoPreg = []; public vecVerPregCalcula = [];
  public vecVerGrupos = []; public vecVerPreguntas = []; public vecVerOpciones = []; public vecVerSubOpcion = [];
  public vecAddGrupos = []; public vecAddPreguntas = []; public vecAddOpciones = []; public vecAddSubOpcion = [];

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvInsert: IngresoService, private cargando: LoaderComponent,
    private srvSelect: SeleccionService, private tools: ToolsService) { }

  ngOnInit() {
    this.encabezado = "Ficha del Estudiante";
    this.obtenerPreguntasCuestionario();
    this.instanciarVectores(1, 0, 1, '', '', localStorage.getItem('localNumEnc'), 1, '', '', '', '');
    this.instanciarVectores(2, 0, 1, '', '', 1, 1, 0, 1, '', '');
    this.instanciarVectores(3, 0, 1, '', '', '', 0, 6, 0, 1, '');
    this.instanciarVectores(4, 0, 1, '', '', 0, 1, 1, '', '', '');
    this.vecVerEncuesta.push({
      datFecha: '', detEstado: '', detVisible: '', fltTiempo: '', intEstado: '', intIdEncuesta: '', intVisible: '', strCreado: '', strDescripcion: '', strNombre: '',
      strRecomendacion: '', strTerminos: ''
    });
  }
  instanciarVectores(op, dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10) {
    this.vecAddGrupos = []; this.vecAddPreguntas = []; this.vecAddOpciones = []; this.vecAddSubOpcion = [];
    if (op == 1)
      this.vecAddGrupos.push({ idGrupo: dato1, numero: dato2, nombre: dato3, descripcion: dato4, ecuesta: dato5, estado: dato6 });
    if (op == 2)
      this.vecAddPreguntas.push({
        idPregunta: dato1, numero: dato2, nombre: dato3, descripcion: dato4, tipo: dato5, grupo: dato6, buscar: dato7, estado: dato8,
        nomGrupo: dato9, verTipo: true, calculada: 0
      });
    if (op == 3)
      this.vecAddOpciones.push({
        idOpcion: dato1, numero: dato2, nombre: dato3, detalle: dato4, enunciado: dato5, peso: dato6, tipo: dato7, pregunta: dato8,
        estado: dato9, nombPreg: dato10
      });
    if (op == 4)
      this.vecAddSubOpcion.push({ idSubOpcion: dato1, numero: dato2, nombre: dato3, detalle: dato4, peso: dato5, opcion: dato6, estado: dato7, nombOp: dato8 });
  }

  async obtenerPreguntasCuestionario() {
    //
    const resCuest = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(2, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerEncuesta = resCuest.resultado ? resCuest.fichaEstudiantil : [];
    //
    const resCalcula = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(3, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerPregCalcula = resCalcula.resultado ? resCalcula.fichaEstudiantil : [];
    //
    const resTipoPreg = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(4, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerTipoPreg = resTipoPreg.resultado ? resTipoPreg.fichaEstudiantil : [];
    //
    const resGrupo = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(5, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerGrupos = resGrupo.resultado ? resGrupo.fichaEstudiantil : [];
    //
    const resPreg = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(6, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerPreguntas = resPreg.resultado ? resPreg.fichaEstudiantil : [];
    //
    const resOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(7, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerOpciones = resOpc.resultado ? resOpc.fichaEstudiantil : [];
    //
    const resSubOpc = await new Promise<any>(resolve => this.srvSelect.obtenerGestionFichaEstudiante(8, localStorage.getItem('localNumEnc'), 'na', 'na', 'na')
      .subscribe(translated => { resolve(translated) }));
    this.vecVerSubOpcion = resSubOpc.resultado ? resSubOpc.fichaEstudiantil : [];
    console.log('-- ENCUESTA --:', this.vecVerEncuesta);
    console.log('-- TIPO PREGUNTA --:', this.vecVerTipoPreg);
    console.log('-- PREGUNTA CALCULADA --:', this.vecVerPregCalcula);
    console.log('-- GRUPOS --:', this.vecVerGrupos);
    console.log('-- PREGUNTAS --:', this.vecVerPreguntas);
    console.log('-- OPCIONES --:', this.vecVerOpciones);
    console.log('-- SUBOPCION --:', this.vecVerSubOpcion);
  }

  //ABRIR MODAL PARA AGREGAR UN GRUPO DE PREGUNTAS
  verModGestionAddGrupo(nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('insUser') == 'true') {
        this.instanciarVectores(1, 0, 1, '', '', localStorage.getItem('localNumEnc'), 1, '', '', '', '');
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //ABRIR MODAL PARA EDITAR UN GRUPO DE PREGUNTAS
  verModGestionModGrupo(objFicha, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('modUser') == 'true') {
        this.instanciarVectores(1, objFicha.gruId, objFicha.gruNumero, objFicha.gruNomb, objFicha.gruDesc, objFicha.encId, objFicha.gruEst, '', '', '', '');
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //ABRIR MODAL PARA AGREGAR UNA PREGUNTA
  verModGestionAddPregunta(objPreg, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('insUser') == 'true') {
        this.instanciarVectores(2, 0, 1, '', '', 1, objPreg.gruId, 0, 1, objPreg.gruNomb, '');
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //ABRIR MODAL PARA EDITAR UNA PREGUNTA
  verModGestionModPregunta(objPreg, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('modUser') == 'true') {
        this.instanciarVectores(2, objPreg.pregId, objPreg.pregNum, objPreg.pregNomb, objPreg.pregDesc, objPreg.pregTipo, objPreg.gruId, objPreg.pregBusca,
          objPreg.pregEst, objPreg.gruNomb, '');
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //ABRIR UN MODAL PARA AGREGAR UNA OPCION
  verModGestionAddOpcion(objPreg, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('insUser') == 'true') {
        this.instanciarVectores(3, 0, 1, '', '', '', 0, 6, objPreg.pregId, 1, objPreg.pregNomb);
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //ABRIR UN MODAL PARA EDITAR UNA OPCION
  verModGestionModOpcion(objOp, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('modUser') == 'true') {
        this.instanciarVectores(3, objOp.opcId, objOp.opcNum, objOp.opcNomb, objOp.opcDet, objOp.opcEnunciado, objOp.opcPeso, objOp.opcTipo, objOp.pregId, objOp.opcEst, objOp.pregNomb);
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //ABRIR UN MODAL PARA AGREGAR UNA SUB-OPCION
  verModGestionAddSubOpcion(objop, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('insUser') == 'true') {
        this.instanciarVectores(4, 0, 1, '', '', 0, objop.opcId, 1, objop.opcNomb, '', '');
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //ABRIR UN MODAL PARA EDITAR UNA SUB-OPCION
  verModGestionModdSubOpcion(objop, nombModal) {
    if (this.vecVerEncuesta[0].intEstado != 1) {
      if (localStorage.getItem('modUser') == 'true') {
        this.instanciarVectores(4, objop.subOpId, objop.subOpNum, objop.subOpNomb, objop.subOpDet, objop.subOpPeso, objop.opcId, objop.subOpEst, objop.opcNomb, '', '');
        this.mr = this.modalService.open(nombModal);
      }
      else
        this.alerti.error("Este perfil no tiene permiso para esta actividad");
    }
    else
      this.alerti.error("El cuestionario está registrado como definitivo, No se puede realizar cambios");
  }
  //VER EL TIPO DE PREGUNTA SELECCIONADA
  verTipoPregunta() {
    this.vecAddPreguntas[0].verTipo = this.vecAddPreguntas[0].tipo == 5 ? false : true;
  }
  //VER LA PREGUNTA CALCULADA
  verPreguntaCalculada() {
    let vecAuxCalculado = this.vecVerPregCalcula.filter(objCal => objCal.intIdPregunta == this.vecAddPreguntas[0].calculada);
    this.vecAddPreguntas[0].nombre = vecAuxCalculado.length > 0 ? vecAuxCalculado[0].strNombre : '';
    this.vecAddPreguntas[0].descripcion = vecAuxCalculado.length > 0 ? vecAuxCalculado[0].strDescripcion : '';
    this.vecAddPreguntas[0].buscar = vecAuxCalculado.length > 0 ? vecAuxCalculado[0].intBuscar : '';
  }
  //FUNCION PARA GENSTIONAR UN GRUPO
  ingresoGrupo(opcion) {
    if (opcion == 2)
      this.gestionRegistroFicha(opcion, this.vecAddGrupos[0].idGrupo, this.vecAddGrupos[0].numero, this.vecAddGrupos[0].nombre, this.vecAddGrupos[0].descripcion,
        this.vecAddGrupos[0].ecuesta, this.vecAddGrupos[0].estado, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na')
    if (opcion == 3)
      this.gestionRegistroFicha(opcion, this.vecAddPreguntas[0].idPregunta, this.vecAddPreguntas[0].numero, this.vecAddPreguntas[0].nombre, this.vecAddPreguntas[0].descripcion,
        this.vecAddPreguntas[0].tipo, this.vecAddPreguntas[0].grupo, this.vecAddPreguntas[0].buscar, this.vecAddPreguntas[0].estado, 'na', 'na', 'na', 'na', 'na', 'na');
    if (opcion == 4)
      this.gestionRegistroFicha(opcion, this.vecAddOpciones[0].idOpcion, this.vecAddOpciones[0].numero, this.vecAddOpciones[0].nombre, this.vecAddOpciones[0].detalle,
        this.vecAddOpciones[0].enunciado, this.vecAddOpciones[0].peso, this.vecAddOpciones[0].tipo, this.vecAddOpciones[0].pregunta, this.vecAddOpciones[0].estado, 'na', 'na', 'na', 'na', 'na');
    if (opcion == 5)
      this.gestionRegistroFicha(opcion, this.vecAddSubOpcion[0].idSubOpcion, this.vecAddSubOpcion[0].numero, this.vecAddSubOpcion[0].nombre, this.vecAddSubOpcion[0].detalle,
        this.vecAddSubOpcion[0].peso, this.vecAddSubOpcion[0].opcion, this.vecAddSubOpcion[0].estado, 'na', 'na', 'na', 'na', 'na', 'na', 'na');
  }

  //
  async gestionRegistroFicha(opc, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14) {
    this.srvInsert.registroGestionFicha(param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, param11, param12, param13, param14, localStorage.getItem('idPersona'), opc).subscribe(res => {
      if (res.respFicha) {
        this.alerti.success('Datos registrados correctamente');
        this.obtenerPreguntasCuestionario();
        this.cerrarModal();
      }
      else
        this.alerti.error('Error inesperado vuelva a intentar más tarde');
    });
  }


  cerrarModal() {
    this.mr.close();
  }
}
